import { useAuthStore } from '@/stores';

export const getToken = () => {
  const { token } = useAuthStore();
  return token;
};

export const getLoginUrl = () => {
  return 'http://login.test.com';
};

export const delay = (timeout: number) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true);
    }, timeout);
  });
};

export function useFileOpener() {
  const openFileInNewTab = (file: File) => {
    if (file) {
      const url = URL.createObjectURL(file);
      var newWin = window.open(url, '_blank');

      setTimeout(function () {
        newWin.document.title = file.name;
      }, 1000);
    }
  };

  return {
    openFileInNewTab
  };
}



export function viewUploadedFile(file: any) {
  const baseURL = import.meta.env.VITE_FILE_URL;
  const fullURL = baseURL + file;
  window.open(fullURL, '_blank');
}
